export default {
  INIT: 'APP/INIT',
  TOGGLE_DIALOG: 'APP/TOGGLE_DIALOG',
  RESET_DIALOGS: 'APP/RESET_DIALOGS',
  CREATE_API_REQUEST: 'APP/CREATE_API_REQUEST',
  FINISH_API_REQUEST: 'APP/FINISH_API_REQUEST',
  UPDATE_DRAWER_OPEN: 'APP/UPDATE_DRAWER_OPEN',
  UPDATE_MOBILE_DRAWER_OPEN: 'APP/UPDATE_MOBILE_DRAWER_OPEN',
}
